module.exports = __webpack_public_path__ + "static/scale-model-of-asu-art-museum-in-tempe-arizona-5ff58db1f9ecfd181aa6e666a5c06b24.png";